/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import type { StackProps } from "@packages/ui";
import {
  Container,
  spacing,
  Stack,
  Text,
  TextWithLinks,
  useIsDesktopViewport,
} from "@packages/ui";
import { forwardRef } from "react";

const stackStyle: Interpolation = {
  gap: spacing.none,
};

const descriptionStyle: Interpolation = {
  marginTop: spacing.s,
  whiteSpace: "pre-line",
};

export type SectionsProps = StackProps & {
  description?: string | null;
  title?: string;
};

export const Sections = forwardRef<any, SectionsProps>(
  ({ children, description, title, ...props }, ref) => {
    const isDesktop = useIsDesktopViewport();

    return (
      <Stack ref={ref} css={stackStyle} {...props}>
        {(title || description) && (
          <Container paddingX paddingY>
            {title && (
              <Text as="h1" overflow="ellipsis" size="s" type="display">
                {title}
              </Text>
            )}
            {description && (
              <TextWithLinks
                as="p"
                css={descriptionStyle}
                expandable={!isDesktop}
                lineClamp={isDesktop ? undefined : 3}
                overflow={isDesktop ? undefined : "ellipsis"}
                size="m"
                type="body"
              >
                {description}
              </TextWithLinks>
            )}
          </Container>
        )}
        {children}
      </Stack>
    );
  },
);

Sections.displayName = "Sections";
